# Called by adding `data: { submit_on_change: true }`to a form element.
class @App.Components.Toggle
  constructor: ->
    $(document).on 'change', '[data-submit-on-change]', (e) ->
      e.preventDefault()
      $el = $(@)
      $el.trigger('submit.rails')

$(document).on 'turbo:load', ->
  new App.Components.Toggle
